export default __webpack_public_path__ + "static/media/loading.dfc60a73.gif";